import React from 'react';
import './PhoneEditor.css';

const PhoneEditor = ({ phones = [], onChange }) => {
  const addPhone = () => {
    onChange([...phones, {
      phone_number: '',
      phone_type: 'mobile',
      is_primary: phones.length === 0,
      label: ''
    }]);
  };

  const removePhone = (index) => {
    const newPhones = phones.filter((_, i) => i !== index);
    // If we removed the primary phone and there are still phones left, make the first one primary
    if (newPhones.length > 0 && !newPhones.some(p => p.is_primary)) {
      newPhones[0].is_primary = true;
    }
    onChange(newPhones);
  };

  const updatePhone = (index, field, value) => {
    const newPhones = [...phones];
    newPhones[index] = { ...newPhones[index], [field]: value };
    
    // If setting a phone as primary, unset other phones
    if (field === 'is_primary' && value === true) {
      newPhones.forEach((phone, i) => {
        if (i !== index) {
          phone.is_primary = false;
        }
      });
    }
    
    onChange(newPhones);
  };

  return (
    <div className="phone-editor">
      <div className="phone-editor-header">
        <label>Phone Numbers</label>
        <button 
          type="button" 
          className="btn btn-sm btn-outline"
          onClick={addPhone}
        >
          + Add Phone
        </button>
      </div>
      
      {phones.length === 0 && (
        <p className="text-muted">No phone numbers added</p>
      )}
      
      {phones.map((phone, index) => (
        <div key={index} className="phone-entry">
          <div className="phone-entry-fields">
            <div className="form-group">
              <label htmlFor={`phone-number-${index}`}>Number</label>
              <input
                type="tel"
                id={`phone-number-${index}`}
                value={phone.phone_number}
                onChange={(e) => updatePhone(index, 'phone_number', e.target.value)}
                placeholder="(555) 123-4567"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor={`phone-type-${index}`}>Type</label>
              <select
                id={`phone-type-${index}`}
                value={phone.phone_type}
                onChange={(e) => updatePhone(index, 'phone_type', e.target.value)}
              >
                <option value="mobile">Mobile</option>
                <option value="home">Home</option>
                <option value="work">Work</option>
                <option value="fax">Fax</option>
                <option value="other">Other</option>
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor={`phone-label-${index}`}>Label (Optional)</label>
              <input
                type="text"
                id={`phone-label-${index}`}
                value={phone.label}
                onChange={(e) => updatePhone(index, 'label', e.target.value)}
                placeholder="e.g., Personal, Business"
              />
            </div>
            
            <div className="form-group form-group-checkbox">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={phone.is_primary}
                  onChange={(e) => updatePhone(index, 'is_primary', e.target.checked)}
                />
                <span>Primary</span>
              </label>
            </div>
          </div>
          
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => removePhone(index)}
            title="Remove phone"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default PhoneEditor;
